<div class="teams-overview-page-container">
    <app-to-page-header
        [setViewFilters]="headerFiltersByView"
        (setDaysForSwitch)="changeSwitchDaysNumber($event)"
        (setIndicatorForSort)="sortTeams($event)"
    ></app-to-page-header>
    <app-to-page-body
        [teamsForOverview]="{currentTeams: teams, backupTeams: defaultTeamsForFilters}"
        [indicatorToShow]="indicatorToShow"
        [aggregatedScoresSetter]="aggregatedScores"
        [userViewFilters]="userViews"
        [membersToShareView]="membersListForViewShare"
        [changesToView]="selectedViewChangesMade"
        [setSelectedViewAfterChanges]="selectedView"
        (quickActionsOpened)="openedQuickActions($event)"
        (goToTeamDashboard)="gotToTeamDashboard($event)"
        (setFilterForScore)="sortTeamsByScore($event)"
        (teamFilterCheck)="teamCheckorUncheck($event)"
        (getAggregatedScores)="getAggregatedScores($event)"
        (pauseLoopEvent)="pauseFeedbackLoop($event)"
        (removeMemberEvent)="removeMember($event)"
        (createNewViewEvent)="createNewView($event)"
        (searchMemberViewEvent)="searchMemberForView($event)"
        (shareViewWithMemberEvent)="shareViewWithMember($event)"
        (openViewEvent)="setSelectedView($event)"
        (patchViewEvent)="patchView($event)"
        (deleteViewEvent)="deleteView($event)"
        (removeMemberFromViewEvent)="removeMemberFromView($event)"
        (saveViewChangesEvent)="saveViewChanges($event)"
    ></app-to-page-body>
</div>